module.exports = __webpack_public_path__ + "resources/icon_50_left_arrow_dark.81274361f047e62c.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/group-or-game-header/img/icon_50_left_arrow_dark.png
// module id = 899
// module chunks = 0